import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";

const formatMoney = (amount) => {
  if (!amount) return "0 FCFA";
  return Number(amount).toLocaleString("en-US") + " FCFA";
};

function PreStudentDashboard() {

  const toggleLanguage = () => {

  const newLanguage =
    i18n.language === "en"
      ? "fr"
      : "en";

  i18n.changeLanguage(newLanguage);

  localStorage.setItem(
    "language",
    newLanguage
  );
};

  const [payments, setPayments] = useState([]);
  const [feeSummary, setFeeSummary] = useState(null);
  const { t } = useTranslation();

  const [studentProfile, setStudentProfile] = useState(null);   // NEW
  const [notification, setNotification] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  
  const token = localStorage.getItem("access");

  useEffect(() => {
  fetchPayments();
  fetchFeeSummary();
  fetchStudentProfile();
  fetchNotification();
}, []);

  const fetchPayments = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/fees/my-payments/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setPayments(res.data);

    } catch (err) {
      console.error(err);
    }

  };

  // NEW
  const fetchFeeSummary = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/students/fee-summary/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setFeeSummary(res.data);

    } catch (err) {
      console.error(err);
    }

  };

  const fetchStudentProfile = async () => {

  try {

    const res = await axios.get(
      "https://api.eduskot.com/api/students/my-profile/",
      {
        headers:{
          Authorization:`Bearer ${token}`
        }
      }
    );

    setStudentProfile(res.data);

  } catch(err) {

    console.error(err);
  }
};

  const fetchNotification = async () => {

    try {

      const res = await axios.get(
        "https://api.eduskot.com/api/results/student-notifications/",
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

      if (res.data.has_notification) {

        setNotification(res.data);

        setShowNotification(true);

      }

    } catch(err) {

      console.error(err);

    }

  };

  const closeNotification = async () => {

    try {

      await axios.post(
        "https://api.eduskot.com/api/results/mark-notification-read/",
        {
          id: notification.id
        },
        {
          headers:{
            Authorization:`Bearer ${token}`
          }
        }
      );

    } catch(err) {

      console.error(err);

    }

    setShowNotification(false);

  };

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <div style={styles.page}>

      {showNotification && notification && (

        <div style={styles.notificationOverlay}>

          <div style={styles.notificationCard}>

            <h2 style={styles.notificationTitle}>
              🎉 {notification.title}
            </h2>

            <p style={styles.notificationMessage}>
              {notification.message}
            </p>

            <button
              style={styles.notificationBtn}
              onClick={closeNotification}
            >
              Continue
            </button>

          </div>

        </div>

      )}

      <div style={styles.header}>

  <h1 style={styles.title}>
    {t("studentPortal")}
  </h1>

  <div style={styles.headerRight}>

    {studentProfile?.profile_picture ? (

      <img
        src={studentProfile.profile_picture}
        alt="profile"
        style={styles.profilePic}
      />

    ) : (

      <div style={styles.defaultPic}>
        👤
      </div>

    )}

    <button
  style={styles.languageBtn}
  onClick={toggleLanguage}
>
  {i18n.language === "en"
    ? "🇫🇷 FR"
    : "🇬🇧 EN"}
</button>

<button
  style={styles.logoutBtn}
  onClick={logout}
>
  {t("logout")}
</button>

  </div>

</div>


      {/* ACTION CARDS */}

<div style={styles.actions}>

  {/* VIEW RESULTS */}

  <div
    style={styles.card}
    onClick={() => window.location.href = "/student-dashboard"}
  >
    <h2>{t("viewResults")}</h2>

    <p>
      {t("viewResultsDesc")}
    </p>

  </div>


  {/* NEW: VIEW SUBJECTS */}

  <div
    style={styles.card}
    onClick={() => window.location.href = "/my-subjects"}
  >
    <h2>{t("viewSubjects")}</h2>

    <p>
      {t("viewSubjectsDesc")}
    </p>

  </div>


  {/* EXISTING: UPLOAD FEES */}

  <div
    style={styles.card}
    onClick={() => window.location.href = "/upload-fee-proof"}
  >
    <h2>{t("uploadFeePayment")}</h2>

    <p>
      {t("uploadFeePaymentDesc")}
    </p>

  </div>

</div>


      {/* ======================= */}
      {/* NEW: FEE SUMMARY CARD */}
      {/* ======================= */}

      {feeSummary && (
        <div style={styles.summaryCard}>

          <h3>{t("schoolFeesSummary")}</h3>

          <div style={styles.summaryGrid}>

  <div style={styles.summaryBox}>
    <span>{t("required")}</span>
    <h2>{formatMoney(feeSummary.required_fee)}</h2>
  </div>

  <div
    style={{
      ...styles.summaryBox,
      background:"#fef3c7"
    }}
  >
    <span>{t("discount")}</span>
    <h2>{formatMoney(feeSummary.discount)}</h2>
  </div>

  <div
    style={{
      ...styles.summaryBox,
      background:"#ede9fe"
    }}
  >
    <span>{t("amountPayable")}</span>
    <h2>
      {formatMoney(
        feeSummary.required_fee -
        feeSummary.discount
      )}
    </h2>
  </div>

  <div
    style={{
      ...styles.summaryBox,
      background:"#e0f2fe"
    }}
  >
    <span>{t("paid")}</span>
    <h2>{formatMoney(feeSummary.total_paid)}</h2>
  </div>

  <div
    style={{
      ...styles.summaryBox,
      background:
        feeSummary.balance > 0
          ? "#fee2e2"
          : "#dcfce7"
    }}
  >
    <span>{t("balance")}</span>
    <h2>{formatMoney(feeSummary.balance)}</h2>
  </div>

</div>

        </div>
      )}


      {/* PAYMENT HISTORY */}

      <div style={styles.historyCard}>

        <h3>{t("paymentHistory")}</h3>

        <div style={styles.tableWrapper}>

          <table style={styles.table}>

            <thead>
              <tr>
                <th>{t("date")}</th>
                <th>{t("method")}</th>
                <th>{t("amount")}</th>
                <th>{t("status")}</th>
              </tr>
            </thead>

            <tbody>

              {payments.length === 0 && (
                <tr>
                  <td colSpan="4">{t("noPaymentRecords")}</td>
                </tr>
              )}

              {payments.map((p) => (
                <tr key={p.id}>
                  <td>{p.payment_date}</td>
                  <td>{p.payment_method}</td>
                  <td>{formatMoney(p.amount)}</td>
                  <td style={{
                    color:
                      p.status === "APPROVED"
                        ? "#16a34a"
                        : p.status === "REJECTED"
                        ? "#ef4444"
                        : "#f59e0b",
                    fontWeight:"600"
                  }}>
                    {p.status}
                  </td>
                </tr>
              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}


const styles = {

  page:{
    minHeight:"100vh",
    padding: window.innerWidth < 768 ? "6px" : "17px",
    fontFamily:"Segoe UI",
    background:"linear-gradient(120deg,#e0f2fe,#f0f9ff)"
  },

  header:{
    display:"flex",
    justifyContent:"space-between",
    alignItems:"center",
    flexWrap:"wrap",
    gap:"15px",
    marginBottom:"40px"
  },

  /*title:{
  margin:0,
  fontSize:"39px",
  fontWeight:"900",
  flex:"1 1 100%"
},*/
  actions:{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(250px,1fr))",
    gap:"20px",
    marginBottom:"40px"
  },


  headerRight:{
  display:"flex",
  alignItems:"center",
  gap:"15px"
},

profilePic:{
  width:"85px",
  height:"85px",
  borderRadius:"50px",
  objectFit:"cover",
  border:"4px solid white",
  boxShadow:"0 8px 20px rgba(0,0,0,0.15)"
},

defaultPic:{
  width:"85px",
  height:"85px",
  borderRadius:"50px",
  background:"white",
  display:"flex",
  alignItems:"center",
  justifyContent:"center",
  fontSize:"30px",
  boxShadow:"0 8px 20px rgba(0,0,0,0.15)"
},

  card:{
    background:"white",
    padding:"30px",
    borderRadius:"14px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)",
    cursor:"pointer",
    transition:"0.2s"
  },

  // NEW
  summaryCard:{
    background:"white",
    padding:"25px",
    borderRadius:"12px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)",
    marginBottom:"40px"
  },

  // NEW
  summaryGrid:{
    display:"grid",
    gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))",
    gap:"15px",
    marginTop:"15px"
  },

  // NEW
  summaryBox:{
    background:"#f1f5f9",
    padding:"20px",
    borderRadius:"10px",
    textAlign:"center"
  },

  languageBtn:{
  padding:"12px 16px",
  background:"#2563eb",
  color:"white",
  border:"none",
  borderRadius:"10px",
  cursor:"pointer",
  fontWeight:"600"
},

  historyCard:{
    background:"white",
    padding:"25px",
    borderRadius:"12px",
    boxShadow:"0 10px 25px rgba(0,0,0,0.08)"
  },

  tableWrapper:{
    overflowX:"auto",
    width:"100%"
  },

  table:{
    width:"100%",
    minWidth:"600px",
    borderCollapse:"collapse",
    textAlign:"center"
  },

  notificationOverlay:{
  position:"fixed",
  top:0,
  left:0,
  right:0,
  bottom:0,
  background:"rgba(0,0,0,0.55)",
  display:"flex",
  justifyContent:"center",
  alignItems:"center",
  zIndex:9999
},

  notificationCard:{
  background:"white",
  width:"90%",
  maxWidth:"550px",
  padding:"35px",
  borderRadius:"18px",
  textAlign:"center",
  boxShadow:"0 20px 60px rgba(0,0,0,0.25)"
},

notificationTitle:{
  color:"#16a34a",
  marginBottom:"15px"
},

  notificationMessage:{
  fontSize:"16px",
  lineHeight:"1.7",
  color:"#334155",
  marginBottom:"25px"
},

  notificationBtn:{
  padding:"12px 24px",
  border:"none",
  borderRadius:"10px",
  background:"#2563eb",
  color:"white",
  fontWeight:"700",
  cursor:"pointer"
},

  logoutBtn:{
    padding:"10px 18px",
    border:"none",
    borderRadius:"8px",
    background:"#ef4444",
    color:"white",
    cursor:"pointer"
  }

  

};

export default PreStudentDashboard;